export const auctionVenderReducer = (
    state = {
        vendersOverView: {},
        myVendersNetWork: [],
        inviteNewVenderLoading: false,
        readVendersOverViewLoading: false,
        readMyNetworkLoading: false,
        singleVenderInfo: {},
        readSingleVenderLoading: false,
        singleVenderAuctions: [],
        readVenderCompletedAuctionsLoading: false,
        singleVenderCompletedAuctions: [],
        venderActiveAuctionsLoading: false,
        venderActiveAuctions:[]
    },
    action
) => {
    switch (action.type) {
        case "INVITTING_NEW_VENDER":
            return {
                ...state,
                inviteNewVenderLoading: true,
            };


        case "NEW_VENDER_INVITED":
            return {
                ...state,
                inviteNewVenderLoading: false,
            };



        case "CANNOT_INVITE_NEW_VENDER":
            return {
                ...state,
                inviteNewVenderLoading: false,
            };





        case "READING_VENDERS_NETWORK":
            return {
                ...state,
                readVendersOverViewLoading: true,
            };


        case "GOT_VENDERS_NETWORK":
            return {
                ...state,
                readVendersOverViewLoading: false,
                vendersOverView: action.payload
            };



        case "CANNOT_READ_VENDERS_NETWORK":
            return {
                ...state,
                readVendersOverViewLoading: false,
            };




        case "GETTING_MY_VENDERS":
            return {
                ...state,
                readMyNetworkLoading: true,
            };


        case "GOT_MY_VENDERS":
            return {
                ...state,
                readMyNetworkLoading: false,
                myVendersNetWork: action.payload
            };


        case "CANNOT_GET_VENDERS":
            return {
                ...state,
                readMyNetworkLoading: false,
            };





        case "GETTING_SINGLE_VENDER":
            return {
                ...state,
                readSingleVenderLoading: true,
            };


        case "GOT_SINGLE_VENDER":
            return {
                ...state,
                readSingleVenderLoading: false,
                singleVenderInfo: action.payload
            };

        case "CANNOT_GET_SINGLE_VENDER":
            return {
                ...state,
                readSingleVenderLoading: false,
            };









        case "GETTING_SINGLE_VENDER_ACTIVE_AUCTION":
            return {
                ...state,
                venderActiveAuctionsLoading: true,
            };


        case "GOT_SINGLE_VENDER_ACTIVE_AUCTION":
            return {
                ...state,
                venderActiveAuctionsLoading: false,
                venderActiveAuctions: action.payload
            };

        case "CANNOT_GET_SINGLE_VENDER_ACTIVE_AUCTION":
            return {
                ...state,
                venderActiveAuctionsLoading: false,
            };






        case "GETTING_SINGLE_VENDER_COMPLETED_AUCTION":
            return {
                ...state,
                readVenderCompletedAuctionsLoading: true,
            };


        case "GOT_SINGLE_VENDER_COMPLETED_AUCTION":
            return {
                ...state,
                readVenderCompletedAuctionsLoading: false,
                singleVenderCompletedAuctions: action.payload
            };

        case "CANNOT_GET_SINGLE_VENDER_COMPLETED_AUCTION":
            return {
                ...state,
                readVenderCompletedAuctionsLoading: false,
            };







        default:
            return state;
    }
};


const initailState = {
  documentData: [],
  loading: false,
  downloadFileLoading: false,
  viewDocumentLoading: false,
  viewDocument: null,
  fileType: null,
  requestedDocuments:[],
  requestingCertificateLoading:false
};

export function allDocumentsReducer(state = initailState, { type, payload,fileType }) {
  switch (type) {
    case "GET_ALL_DOCUMENT":
      return { ...state, documentData: payload, loading: false };
    case "SHOW_DOCUMENT_LOADING":
      return { ...state, loading: true };
    case "SHOW_DOCUMENT_LOADDED":
      return { ...state, loading: false };
    case "DOCUMENT_UPLOAD":
      return { ...state };

    case "DOWNLOAD_FILE_SUCCESS":
      return { ...state, downloadFileLoading: false };
    case "DOWNLOADING_FILE":
      return { ...state, downloadFileLoading: true };



         case "REQUESTED_CERTIFICATE":
      return { ...state, requestingCertificateLoading: false };

          case "CANNOT_REQUEST_CERTIFICATE":
      return { ...state, requestingCertificateLoading: false };

    case "REQUESTTING_CERTIFICSTE":
      return { ...state, requestingCertificateLoading: true };

    case "FAILED_DOWNLOAD_FILE":
      return { ...state, downloadFileLoading: false };
    case "SHOW_REJECT":
      return { ...state, loading: true };
    case "CANNOT_REJECT":
      return { ...state, loading: false };
    case "SHOW_CONFIRM":
      return { ...state, loading: true };
    case "CANNOT_CONFIRM":
      return { ...state, loading: false };
    case "VIEW_DOCUMENT_LOADING":
      return { ...state, viewDocumentLoading: true };
    case "VIEW_DOCUMENT_SUCCESS":
      return { ...state, viewDocumentLoading: false, viewDocument: payload, fileType: fileType };
       case "GOT_REQUESTED_DOCUMENTS":
      return { ...state,  requestedDocuments: payload, };
   
   
      case "VIEW_DOCUMENT_FAILED":
      return { ...state, viewDocumentLoading: false };
    default:
      return state;
  }
}
